/**
 * Generated from PlanterPlantingLayout.fla
 */
export function PlanterPlantingLayout(this: IPlanterPlantingLayout) {
	const button = this.button;
	if (!button[0] && button.elementFactory) {
		button[0] = button.elementFactory(0,undefined);
	}
	if (button[0]) {
		PlanterPlantingLayout_button0.call(button[0] as IPlanterPlantingLayout_button0);
		button[0].x = 578.5;
		button[0].y = 621.75;
		button[0].width = 93.00;
		button[0].height = 92.50;
		if (button[0].onLayout) button[0].onLayout();
	}
	if (!button[1] && button.elementFactory) {
		button[1] = button.elementFactory(1,undefined);
	}
	if (button[1]) {
		PlanterPlantingLayout_button1.call(button[1] as IPlanterPlantingLayout_button1);
		button[1].x = 684.25;
		button[1].y = 621.75;
		button[1].width = 86.50;
		button[1].height = 86.50;
		if (button[1].onLayout) button[1].onLayout();
	}
	if (!button[2] && button.elementFactory) {
		button[2] = button.elementFactory(2,undefined);
	}
	if (button[2]) {
		PlanterPlantingLayout_button2.call(button[2] as IPlanterPlantingLayout_button2);
		button[2].x = 786.25;
		button[2].y = 621.75;
		button[2].width = 86.50;
		button[2].height = 86.50;
		if (button[2].onLayout) button[2].onLayout();
	}
	if (!button[3] && button.elementFactory) {
		button[3] = button.elementFactory(3,undefined);
	}
	if (button[3]) {
		PlanterPlantingLayout_button3.call(button[3] as IPlanterPlantingLayout_button3);
		button[3].x = 889.25;
		button[3].y = 621.75;
		button[3].width = 86.50;
		button[3].height = 86.50;
		if (button[3].onLayout) button[3].onLayout();
	}
	if (!button[4] && button.elementFactory) {
		button[4] = button.elementFactory(4,undefined);
	}
	if (button[4]) {
		PlanterPlantingLayout_button4.call(button[4] as IPlanterPlantingLayout_button4);
		button[4].x = 991.25;
		button[4].y = 621.75;
		button[4].width = 86.50;
		button[4].height = 86.50;
		if (button[4].onLayout) button[4].onLayout();
	}
	if (!button[5] && button.elementFactory) {
		button[5] = button.elementFactory(5,undefined);
	}
	if (button[5]) {
		PlanterPlantingLayout_button5.call(button[5] as IPlanterPlantingLayout_button5);
		button[5].x = 1094.25;
		button[5].y = 621.75;
		button[5].width = 86.50;
		button[5].height = 86.50;
		if (button[5].onLayout) button[5].onLayout();
	}
	const planter = this.planter;
	if (!planter[0] && planter.elementFactory) {
		planter[0] = planter.elementFactory(0,undefined);
	}
	if (planter[0]) {
		PlanterPlantingLayout_planter0.call(planter[0] as IPlanterPlantingLayout_planter0);
		planter[0].x = 682.25;
		planter[0].y = 406.5;
		planter[0].width = 70.50;
		planter[0].height = 60.50;
		if (planter[0].onLayout) planter[0].onLayout();
	}
	if (!planter[1] && planter.elementFactory) {
		planter[1] = planter.elementFactory(1,undefined);
	}
	if (planter[1]) {
		PlanterPlantingLayout_planter0.call(planter[1] as IPlanterPlantingLayout_planter0);
		planter[1].x = 1017.25;
		planter[1].y = 402.5;
		planter[1].width = 70.50;
		planter[1].height = 60.50;
		if (planter[1].onLayout) planter[1].onLayout();
	}
	if (!planter[2] && planter.elementFactory) {
		planter[2] = planter.elementFactory(2,undefined);
	}
	if (planter[2]) {
		PlanterPlantingLayout_planter0.call(planter[2] as IPlanterPlantingLayout_planter0);
		planter[2].x = 757.25;
		planter[2].y = 519.5;
		planter[2].width = 70.50;
		planter[2].height = 60.50;
		if (planter[2].onLayout) planter[2].onLayout();
	}
	if (!planter[3] && planter.elementFactory) {
		planter[3] = planter.elementFactory(3,undefined);
	}
	if (planter[3]) {
		PlanterPlantingLayout_planter0.call(planter[3] as IPlanterPlantingLayout_planter0);
		planter[3].x = 941.25;
		planter[3].y = 519.5;
		planter[3].width = 70.50;
		planter[3].height = 60.50;
		if (planter[3].onLayout) planter[3].onLayout();
	}
	const bg = this.bg;
	PlanterPlantingLayout_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384.5;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const abby = this.abby;
	PlanterPlantingLayout_abby.call(this.abby);
	abby.x = 524.5;
	abby.y = 675;
	abby.width = 331.00;
	abby.height = 409.00;
	if (abby.onLayout) abby.onLayout();
	const windchimes = this.windchimes;
	PlanterPlantingLayout_windchimes.call(this.windchimes);
	windchimes.x = 1255.5;
	windchimes.y = 241.75;
	windchimes.width = 134.00;
	windchimes.height = 227.50;
	if (windchimes.onLayout) windchimes.onLayout();
	const hose = this.hose;
	PlanterPlantingLayout_hose.call(this.hose);
	hose.x = 1249.75;
	hose.y = 501.75;
	hose.width = 180.00;
	hose.height = 258.00;
	if (hose.onLayout) hose.onLayout();
	const blueButterfly = this.blueButterfly;
	PlanterPlantingLayout_blueButterfly.call(this.blueButterfly);
	blueButterfly.x = 771.75;
	blueButterfly.y = 285.75;
	blueButterfly.width = 68.00;
	blueButterfly.height = 58.00;
	if (blueButterfly.onLayout) blueButterfly.onLayout();
	const bee = this.bee;
	PlanterPlantingLayout_bee.call(this.bee);
	bee.x = 918;
	bee.y = 174.5;
	bee.width = 40.00;
	bee.height = 41.00;
	if (bee.onLayout) bee.onLayout();
	const shovel = this.shovel;
	PlanterPlantingLayout_shovel.call(this.shovel);
	shovel.x = 532.5;
	shovel.y = 502;
	shovel.width = -257.00;
	shovel.height = 210.50;
	if (shovel.onLayout) shovel.onLayout();
	const yellowButterfly = this.yellowButterfly;
	PlanterPlantingLayout_yellowButterfly.call(this.yellowButterfly);
	yellowButterfly.x = 1103;
	yellowButterfly.y = 225;
	yellowButterfly.width = 68.00;
	yellowButterfly.height = 58.00;
	if (yellowButterfly.onLayout) yellowButterfly.onLayout();
	const purpleButterfly = this.purpleButterfly;
	PlanterPlantingLayout_purpleButterfly.call(this.purpleButterfly);
	purpleButterfly.x = 613;
	purpleButterfly.y = 118;
	purpleButterfly.width = 68.00;
	purpleButterfly.height = 58.00;
	if (purpleButterfly.onLayout) purpleButterfly.onLayout();
	const anotherBee = this.anotherBee;
	PlanterPlantingLayout_bee.call(this.anotherBee);
	anotherBee.x = 832;
	anotherBee.y = 384;
	anotherBee.width = 40.00;
	anotherBee.height = 41.00;
	if (anotherBee.onLayout) anotherBee.onLayout();
	const buttonsBg = this.buttonsBg;
	PlanterPlantingLayout_buttonsBg.call(this.buttonsBg);
	buttonsBg.x = 832.25;
	buttonsBg.y = 624.25;
	buttonsBg.width = 681.50;
	buttonsBg.height = 132.50;
	if (buttonsBg.onLayout) buttonsBg.onLayout();
	const customizedPlanter = this.customizedPlanter;
	PlanterPlantingLayout_customizedPlanter.call(this.customizedPlanter);
	customizedPlanter.x = 846;
	customizedPlanter.y = 406.5;
	customizedPlanter.width = 0.00;
	customizedPlanter.height = 0.00;
	if (customizedPlanter.onLayout) customizedPlanter.onLayout();
	const homeButton = this.homeButton;
	PlanterPlantingLayout_homeButton.call(this.homeButton);
	homeButton.x = 428;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	return this;
}
function PlanterPlantingLayout_bg(this: IPlanterPlantingLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlanterParty-Background.png", 0.500, 0.500);
	return this;
}
function PlanterPlantingLayout_abby(this: IPlanterPlantingLayout_abby) {
	if (this.setLayoutTexture) this.setLayoutTexture("abby.png", 0.502, 1.002);
	return this;
}
function PlanterPlantingLayout_windchimes(this: IPlanterPlantingLayout_windchimes) {
	if (this.setLayoutTexture) this.setLayoutTexture("windchime.png", 0.507, 0.501);
	return this;
}
function PlanterPlantingLayout_hose(this: IPlanterPlantingLayout_hose) {
	if (this.setLayoutTexture) this.setLayoutTexture("hose.png", 0.360, 0.313);
	return this;
}
function PlanterPlantingLayout_blueButterfly(this: IPlanterPlantingLayout_blueButterfly) {
	if (this.setLayoutTexture) this.setLayoutTexture("bluebutterfly.png", 0.438, 0.392);
	return this;
}
function PlanterPlantingLayout_bee(this: IPlanterPlantingLayout_bee) {
	if (this.setLayoutTexture) this.setLayoutTexture("Bee.png", 0.500, 0.500);
	return this;
}
function PlanterPlantingLayout_shovel(this: IPlanterPlantingLayout_shovel) {
	if (this.setLayoutTexture) this.setLayoutTexture("shovel.png", 0.130, 0.356);
	return this;
}
function PlanterPlantingLayout_yellowButterfly(this: IPlanterPlantingLayout_yellowButterfly) {
	if (this.setLayoutTexture) this.setLayoutTexture("yellowbutterfly.png", 0.500, 0.500);
	return this;
}
function PlanterPlantingLayout_purpleButterfly(this: IPlanterPlantingLayout_purpleButterfly) {
	if (this.setLayoutTexture) this.setLayoutTexture("purplebutterfly.png", 0.500, 0.500);
	return this;
}
function PlanterPlantingLayout_buttonsBg(this: IPlanterPlantingLayout_buttonsBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("UIContainer.png", 0.500, 0.500);
	return this;
}
function PlanterPlantingLayout_customizedPlanter(this: IPlanterPlantingLayout_customizedPlanter) {
	return this;
}
function PlanterPlantingLayout_button0(this: IPlanterPlantingLayout_button0) {
	return this;
}
function PlanterPlantingLayout_button1(this: IPlanterPlantingLayout_button1) {
	return this;
}
function PlanterPlantingLayout_button2(this: IPlanterPlantingLayout_button2) {
	return this;
}
function PlanterPlantingLayout_button3(this: IPlanterPlantingLayout_button3) {
	return this;
}
function PlanterPlantingLayout_button4(this: IPlanterPlantingLayout_button4) {
	return this;
}
function PlanterPlantingLayout_button5(this: IPlanterPlantingLayout_button5) {
	return this;
}
function PlanterPlantingLayout_planter0(this: IPlanterPlantingLayout_planter0) {
	if (this.setLayoutTexture) this.setLayoutTexture("Planter.png", 0.496, 1.008);
	return this;
}
function PlanterPlantingLayout_homeButton(this: IPlanterPlantingLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
interface IPlanterPlantingLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPlanterPlantingLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPlanterPlantingLayoutSprite extends IPlanterPlantingLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPlanterPlantingLayoutText extends IPlanterPlantingLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPlanterPlantingLayoutPolygon extends Array<number> {
}
interface IPlanterPlantingLayout {
	readonly button: IPlanterPlantingLayoutArray<IPlanterPlantingLayout_button0|IPlanterPlantingLayout_button1|IPlanterPlantingLayout_button2|IPlanterPlantingLayout_button3|IPlanterPlantingLayout_button4|IPlanterPlantingLayout_button5>;
	readonly planter: IPlanterPlantingLayoutArray<IPlanterPlantingLayout_planter0>;
	readonly bg: IPlanterPlantingLayout_bg;
	readonly abby: IPlanterPlantingLayout_abby;
	readonly windchimes: IPlanterPlantingLayout_windchimes;
	readonly hose: IPlanterPlantingLayout_hose;
	readonly blueButterfly: IPlanterPlantingLayout_blueButterfly;
	readonly bee: IPlanterPlantingLayout_bee;
	readonly shovel: IPlanterPlantingLayout_shovel;
	readonly yellowButterfly: IPlanterPlantingLayout_yellowButterfly;
	readonly purpleButterfly: IPlanterPlantingLayout_purpleButterfly;
	readonly anotherBee: IPlanterPlantingLayout_bee;
	readonly buttonsBg: IPlanterPlantingLayout_buttonsBg;
	readonly customizedPlanter: IPlanterPlantingLayout_customizedPlanter;
	readonly homeButton: IPlanterPlantingLayout_homeButton;
}
interface IPlanterPlantingLayout_bg extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_abby extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_windchimes extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_hose extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_blueButterfly extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_bee extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_shovel extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_yellowButterfly extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_purpleButterfly extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_buttonsBg extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_customizedPlanter extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_button0 extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_button1 extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_button2 extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_button3 extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_button4 extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_button5 extends IPlanterPlantingLayoutContainer {
}
interface IPlanterPlantingLayout_planter0 extends IPlanterPlantingLayoutSprite {
}
interface IPlanterPlantingLayout_homeButton extends IPlanterPlantingLayoutSprite {
}
